import { LambdaType } from './lambda-type';

export type MessageCallback = (message: any, options: IPubSubMessageOptions) => void;
export type ReplyCallback = (message: any, options: IPubSubMessageOptions) => Promise<any>;

export enum Pattern {
    PubSub,
    RequestReply
}

export enum SerializationProfile {
    // Order and numbers of the values should be preserved as this enum gets serialized and a change in order
    // can cause n/n-1 issues during deployment.
    JSONB = 0,
    JSON = 1,
    JSOND = 2,
    Disabled = 3,
    COMPRESSEDJSON = 4,
}

export interface IPubSubMessageOptions {
    pattern: Pattern;
    requestTimeoutMs?: number;
    endpoint?: string;
    validateEndpoint?: boolean;
    lambdaType?: LambdaType;
    serializationProfile?: SerializationProfile;
    serializationOptions?: any;
    headers?: any;
    endpointKey?: string;
    endpointKeyExpiryTimeoutMs?: number;
}

export interface IPubSub {
    initialize(): Promise<void>;
    close(immediate?: boolean): Promise<void>;

    consume(lambdaType: LambdaType, onMessage: MessageCallback): void;
    reply(lambdaType: LambdaType, onMessage: ReplyCallback): void;
    produce(lambdaType: LambdaType, message: any, options?: IPubSubMessageOptions): Promise<any>;

    getMyEndpoint(useHashForUri?: boolean): string;
    getOrigin(topic: string, useHashForUri?: boolean): string;
}
